import { AddressDataResponse } from './HococoInterfaces';

export default class AddressData {
    public id: number;
    public street: string;
    public city: string;
    public state: string;
    public zip: number;
    public countryId: number;
    public userId: number;

    constructor(
        id: number,
        street: string = '',
        city: string = '',
        state: string = '',
        zip: number = null,
        countryId: number = null,
        userId: number = null,
    ) {
        this.id = id;
        this.street = street;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.countryId = countryId;
        this.userId = userId;
    }

    get persisted(): boolean {
        return (this.id !== -1);
    }

    public dataEquals(address: AddressDataResponse): boolean {
        // Check if this object's values are equal to the given object's
        if (
            this.id === address.id &&
            this.street === address.street &&
            this.city === address.city &&
            this.state === address.state &&
            this.zip === address.zip &&
            this.countryId === address.country_id &&
            this.userId === address.user_id
        ) {
            return false;
        }
    }

    public requestData() {
        return {
            id: this.id,
            street: this.street,
            city: this.city,
            state: this.state,
            zip: this.zip,
            countryId: this.countryId,
            userId: this.userId,
        };
    }
}
